import { render, staticRenderFns } from "./TabVestingWhitelist.vue?vue&type=template&id=3ce86172"
import script from "./TabVestingWhitelist.vue?vue&type=script&lang=js"
export * from "./TabVestingWhitelist.vue?vue&type=script&lang=js"
import style0 from "./TabVestingWhitelist.vue?vue&type=style&index=0&id=3ce86172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports